import { api_GET, api_POST, api_PUT } from "../api/_axios.js";

const indiceiqg_api =
{
    getAll: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`indiceiqg`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getListaIndiceIQG: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`indiceiqg/getListaIndiceIQG`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getIndiceIQG: function (indiceIQG_Id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`indiceiqg/GetIndiceIQG/${indiceIQG_Id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getListaIndiceSinteticoIQGByIndicePrincipal: function (indiceIQG_Id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`indiceiqg/getListaIndiceSinteticoIQGByIndicePrincipal/${indiceIQG_Id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getListaIndiceAnaliticoIQGByIndicePrincipal: function (indiceIQG_Id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`indiceiqg/getListaIndiceAnaliticoIQGByIndicePrincipal/${indiceIQG_Id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getIndiceSinteticoIQG: function (indiceSinteticoIQG_Id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`indiceiqg/GetIndiceSinteticoIQG/${indiceSinteticoIQG_Id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getIndiceAnaliticoIQG: function (indiceAnaliticoIQG_Id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`indiceiqg/GetIndiceAnaliticoIQG/${indiceAnaliticoIQG_Id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    PostRelatorioIQG: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`indiceiqg/PostRelatorioiqg`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    postIndiceIQG: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`indiceiqg/PostIndiceIQG`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    putIndiceIQG: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`indiceiqg/PutIndiceIQG`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    postIndiceSinteticoIQG: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`indiceiqg/PostIndiceSinteticoIQG`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    putIndiceSinteticoIQG: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`indiceiqg/PutIndiceSinteticoIQG`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    postIndiceAnaliticoIQG: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`indiceiqg/PostIndiceAnaliticoIQG`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    
    putIndiceAnaliticoIQG: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`indiceiqg/PutIndiceAnaliticoIQG`, json_submit).then(result => {
                resolve(result)
            });
        });
        
        return promise;
    }
}

export default indiceiqg_api;
